// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gouE","content":"styles_content__2mny5","tableWrap":"styles_tableWrap__1RZbT"};